import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import {
  Card,
  CardContent,
  Grid,
  Paper,
} from '@material-ui/core';
import { 
  renderDateTextField2,
  renderMultiLineTextField,
  renderSelectField6,
} from '../../../form-global-components/components-form-components-for-react-final-form';
import {
  HEALTH_DIAGNOSIS,
  NO_YES,
} from '../../../../actions/action-constants';
class FormFieldsIntakeAssessWlnsPrgmPlng extends Component {
  render() {
    return (
      <div>
        <Paper >
          <Card>
            <CardContent>

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Field
                    autoFocus
                    component={renderSelectField6}
                    locked={this.props.locked}
                    dataArray={NO_YES}
                    id='prescribedmedications'
                    name='prescribedmedications'
                    label='Prescribed Medications'
                    footerMessage=''
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Field
                    autoFocus
                    component={renderSelectField6}
                    locked={this.props.locked}
                    dataArray={NO_YES}
                    id='medicationsupplyprovidedwithclient'
                    name='medicationsupplyprovidedwithclient'
                    label='Medication Supply Provided with Client'
                    footerMessage=''
                  />
                </Grid>
              </Grid>

              {this.props.programSelected === '1' ||
              this.props.programSelected === '2' ? (
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <Field
                      locked={this.props.locked}
                      component={renderDateTextField2}
                      id='clientrrchdeligibilitydate'
                      name='clientrrchdeligibilitydate'
                      label='(RRC) HD Eligibility Date'
                    />
                  </Grid>
                </Grid>
              ) : null}

              {this.props.programSelected === '5' ? (
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <Field
                      autoFocus
                      component={renderSelectField6}
                      locked={this.props.locked}
                      dataArray={NO_YES}
                      id='clientbhtsopreferralcompleted'
                      name='clientbhtsopreferralcompleted'
                      label='(BHTs) Client OP Referral Completed ( in 14 days )'
                      footerMessage=''
                    />
                  </Grid>
                </Grid>
              ) : null}

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Field
                    autoFocus
                    component={renderSelectField6}
                    locked={this.props.locked}
                    dataArray={HEALTH_DIAGNOSIS}
                    id='primarybehavioralhealthdiagnosis'
                    name='primarybehavioralhealthdiagnosis'
                    label='Primary Behavioral Health Diagnosis'
                    footerMessage=''
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Field
                    autoFocus
                    component={renderSelectField6}
                    locked={this.props.locked}
                    dataArray={HEALTH_DIAGNOSIS}
                    id='secondarybehavioralhealthdiagnosis'
                    name='secondarybehavioralhealthdiagnosis'
                    label='Secondary Behavioral Health Diagnosis'
                    footerMessage=''
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Field
                    locked={this.props.locked}
                    component={renderMultiLineTextField}
                    id='behavioralhealthdiagnosiscomment'
                    name='behavioralhealthdiagnosiscomment'
                    label='Behavioral Health Diagnosis Comment'
                    rows='6'
                    emptyText='Please be aware of HIPAA laws and concerns. Enter only what is required, nothingg more that is not permitted by law.'
                    footerMessage='Please be aware of HIPAA laws and concerns. Enter only what is required, nothing more that is not permitted by law.'
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Field
                    locked={this.props.locked}
                    component={renderMultiLineTextField}
                    id='clientintakeandassessmentcomments'
                    name='clientintakeandassessmentcomments'
                    label='Client Intake and Assessment Comment'
                    rows='6'
                    emptyText='Please be aware of HIPAA laws and concerns. Enter only what is required, nothingg more that is not permitted by law.'
                    footerMessage='Please be aware of HIPAA laws and concerns. Enter only what is required, nothingg more that is not permitted by law.'
                  />
                </Grid>
              </Grid>

            </CardContent>
          </Card>
        </Paper>  
        
      </div>
    );
  }
}
FormFieldsIntakeAssessWlnsPrgmPlng.propTypes = {
  locked: PropTypes.bool,
  programSelected: PropTypes.string,
}
export default FormFieldsIntakeAssessWlnsPrgmPlng;
